export default "__VITE_ASSET__CZnwPW1e__"